<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Port</th>
        <th class="text-sm">TX Power (dBm)</th>
        <!-- <th class="text-sm">RX Power (dBm)</th> -->
        <th class="text-sm">Current (mA)</th>
        <th class="text-sm">Voltage (V)</th>
        <th class="text-sm">Temperature (°C)</th>
        <th class="text-sm">Status</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="7">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else-if="bdcomPonInfo?.ports && bdcomPonInfo.ports.length">
        <tr
          v-for="port in bdcomPonInfo.ports"
          :key="port.index"
        >
          <td class="text-sm font-weight-bold">{{ port.interface_name }}</td>
          <td class="text-sm" :class="getTxPowerClass(port.txpower)">
            {{ formatPower(port.txpower) }}
          </td>
          <!-- <td class="text-sm" :class="getRxPowerClass(port.rx_power)">
            {{ formatRxPower(port) }}
          </td> -->
          <td class="text-sm">{{ formatCurrent(port.current) }}</td>
          <td class="text-sm">{{ formatVoltage(port.voltage) }}</td>
          <td class="text-sm" :class="getTemperatureClass(port.temp)">
            {{ formatTemperature(port.temp) }}
          </td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getStatusClass(port)"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ getStatusText(port) }}
            </span>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="7" class="text-center">
            <Skalaton />
            <!-- No PON port data available -->

          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'BdcomGponPonTable',
  components: {
    Skalaton
  },
  props: {
    bdcomPonInfo: Object,
    bdcomBasicInfo: Object,
    bdcomPortInfo: Object,
    loading: Boolean
  },
  methods: {
    formatPower(value) {
      if (value === null || value === undefined) return 'N/A';
      return `${value} dBm`;
    },
    
    formatRxPower(port) {
      // For BDCOM GPON, RX power is typically -40 when no ONUs are connected
      // or we can get it from uplink data if available
      if (port.rx_power !== undefined && port.rx_power !== null) {
        return `${port.rx_power} dBm`;
      }
      return '-40 dBm'; // Default for GPON when no ONUs
    },
    
    formatCurrent(value) {
      if (value === null || value === undefined) return 'N/A';
      return `${value} mA`;
    },
    
    formatVoltage(value) {
      if (value === null || value === undefined) return 'N/A';
      return `${value} V`;
    },
    
    formatTemperature(value) {
      if (value === null || value === undefined) return 'N/A';
      return `${value}°C`;
    },
    
    getTxPowerClass(value) {
      if (value === null || value === undefined) return 'text-muted';
      
      // GPON TX power should be positive (typically 1.5-7 dBm)
      if (value >= 1.5 && value <= 8) return 'text-success'; // Normal range
      if (value > 0 && value < 1.5) return 'text-warning'; // Low but working
      return 'text-danger'; // Out of range
    },
    
    getRxPowerClass(value) {
      if (value === null || value === undefined) return 'text-muted';
      
      // RX power for GPON (when ONUs are connected)
      if (value > -25) return 'text-success'; // Excellent
      if (value > -28) return 'text-warning'; // Warning
      return 'text-danger'; // Critical
    },
    
    getTemperatureClass(value) {
      if (value === null || value === undefined) return 'text-muted';
      
      if (value < 50) return 'text-success'; // Normal temperature
      if (value < 60) return 'text-warning'; // Warning temperature
      return 'text-danger'; // Critical temperature
    },
    
    getStatusClass(port) {
      // Check if port has valid TX power and current
      if (port.txpower > 0 && port.current > 0) {
        return 'bg-success'; // Active and working
      }
      return 'bg-secondary'; // Inactive
    },
    
    getStatusText(port) {
      // Check if port has valid TX power and current
      if (port.txpower > 0 && port.current > 0) {
        return 'Active';
      }
      return 'Inactive';
    },
    
    // Helper to get connection status from port info
    getConnectionStatus(interfaceName) {
      if (!this.bdcomPortInfo || !this.bdcomPortInfo.ports) return 'Unknown';
      
      const portStatus = this.bdcomPortInfo.ports.find(p => p.interface === interfaceName);
      return portStatus ? portStatus.connection : 'Unknown';
    }
  }
}
</script>